import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import Modal from "../../../layouts/Modal";
import { ButtonInput } from "../Inputs/ButtonInput";

interface ConfirmProps {
  open: boolean;
  setOpen: any;
  title: string;
  message: string;
  confirmButtonText: string | null;
  onConfirm: any;
  isLoading: boolean;
  // For a confirm that requires input in `children` first - the button was previously only ever
  // disabled while loading, so a modal collecting a mandatory field had no way to hold it shut.
  confirmDisabled?: boolean;
  Icon?: React.ReactNode;
  iconBg?: string;
  children?: React.ReactNode;
}

export default function ConfirmModal({ open, setOpen, title, message, confirmButtonText = null, onConfirm, isLoading, confirmDisabled = false, Icon = <ExclamationCircleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />, iconBg = "bg-red-100", children }: ConfirmProps) {
  const { t } = useTranslation("common");

  return (
    <Modal open={open} setOpen={setOpen} width={"max-w-2xl"}>
      <div className="sm:flex sm:items-start">
        <div className={`mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full ${iconBg} sm:mx-0 sm:h-10 sm:w-10`}>
          {Icon}
        </div>
        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
            {title}
          </h3>
          <div className="mt-2 py-4">
            <p className="text-sm text-gray-500 whitespace-pre-line">
              {message}
            </p>
            {children}
          </div>
        </div>
      </div>
      <div className="justify-between mt-5 sm:mt-4 sm:ml-10 sm:pl-4 sm:flex">
        <ButtonInput
          label={confirmButtonText ?? t("Confirm")}
          onClick={() => onConfirm()}
          isLoading={isLoading}
          disabled={isLoading || confirmDisabled}
          classes="!bg-red-600 hover:!bg-red-700"
        />
        <ButtonInput
          label={t("Cancel")}
          onClick={() => setOpen(false)}
          disabled={isLoading}
          classes="border border-gray-300 !bg-white !text-gray-700 hover:!bg-gray-50 mt-3 sm:mt-0"
        />
      </div>
    </Modal>
  )
}
